import React from "react";
import { IDSButton, IDSInput, IDSLink, IDSAlert, IDSSpinner, IDSCard } from "@inera/ids-react";
import AutosaveIndicator from "../../common/AutosaveIndicator";
import InfoTooltip from "../../common/InfoTooltip";

const TYPE_PATTERNS = {
  datetime:    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/,
  date:        /^\d{8}$/,
  timestamp:   /^\d{14}$/,
  integer:     /^\d+$/,
  personnummer:/^\d{12}$/,
  oid:         /^[\d.]+$/,
  url:         /^https?:\/\//,
};

const TYPE_ERROR_MESSAGES = {
  datetime:    'Ogiltigt format. Förväntat: YYYY-MM-DDTHH:mm:ss',
  date:        'Ogiltigt format. Förväntat: YYYYMMDD (8 siffror)',
  timestamp:   'Ogiltigt format. Förväntat: ÅÅÅÅMMDDttmmss (14 siffror)',
  integer:     'Måste vara ett heltal',
  personnummer:'Måste vara 12 siffror utan bindestreck',
  oid:         'Ogiltigt OID-format (siffror separerade med punkter)',
  url:         'Måste börja med http:// eller https://',
};

const validateValue = (value, type) => {
  if (!value || !type || !TYPE_PATTERNS[type]) return true;
  return TYPE_PATTERNS[type].test(value);
};

const ParameterSection = ({
  selectedContract,
  parameters,
  loadingParams,
  errorParams,
  onContractParamChange,
  onSaveParams,
  autosaveStatus,
  paramMetadata = {},
}) => {
  const contractParams = parameters?.testsuite?.contractParams || {};

  return (
    <>
      {/* Documentation link */}
      {/* <div className="ids-mb-4">
        {selectedContract && (
          <IDSLink colorPreset={1}>
            <a
              href={`/test-runner/service-contract-doc?serviceContractName=${selectedContract}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Visa tjänstekontraktets dokumentation
            </a>
          </IDSLink>
        )}
      </div> */}

      {/* Parameters */}
      <div>
        {loadingParams && (
          <div className="ids-flex" style={{ alignItems: "center", gap: "0.5rem" }}>
            <IDSSpinner size="s" />
            <span>Laddar parametrar...</span>
          </div>
        )}
        {errorParams && (
          <IDSAlert type="error">
            <p>Fel: {errorParams}</p>
          </IDSAlert>
        )}

        {parameters && (
          <IDSCard className="ids-mb-6">
            {Object.entries(contractParams).map(([key, value]) => {
              const meta = paramMetadata[key];
              const isValid = validateValue(value, meta?.type);
              return (
                <div key={key} className="ids-mb-3">
                  <IDSInput
                    label={<>{key}<InfoTooltip info={meta?.description} /></>}
                    type="text"
                    value={value || ""}
                    placeholder={meta?.placeholder || ""}
                    invalid={!isValid}
                    errorMsg={!isValid ? TYPE_ERROR_MESSAGES[meta?.type] : undefined}
                    onChange={(e) => onContractParamChange(key, e.target.value)}
                  />
                </div>
              );
            })}
          </IDSCard>
        )}

        <div className="ids-mt-6" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <IDSButton size="m" onClick={onSaveParams}>
            Spara parametrar
          </IDSButton>
        </div>
        {/* Fixed top-right indicator — always visible regardless of scroll position */}
        <AutosaveIndicator status={autosaveStatus} fixed />
      </div>
    </>
  );
};

export default ParameterSection;
